define(function(require) {
    // GEO09E04_MUNCP layer definition config
    return {
        LAYER_ID : "GEO09E04_MUNCP_GEN",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "CARTOVISTA",
        USE_TYPED_ARRAY : true,
        INDEX : 1,
        FIELDS : [
            {ID : "CD_MUNCP", NAME : "Code", DATA_TYPE : "STRING"},
            {ID : "NOM_MUNCP", NAME : "Nom", DATA_TYPE : "STRING"},
            {ID : "STAT_MUNCP", NAME : "Statut", DATA_TYPE : "STRING"}
        ],
        STYLES : [
            {
                ID : "Municipalité",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "NONE",
                        STROKE_COLOR : "rgba(133,133,133,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 1
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    COLOR : "rgba(50,50,50,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8,
                    VISIBLE : false
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Municipalité",
            FEATURE_ID_DATACOLUMN : "CD_MUNCP",
            FEATURE_NAME_DATACOLUMN : "NOM_MUNCP",
            DATATIP_DATACOLUMNS : ["CD_MUNCP", "NOM_MUNCP"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_MUNCP", "NOM_MUNCP", "STAT_MUNCP"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_MUNCP", "NOM_MUNCP", "STAT_MUNCP"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["NOM_MUNCP", "CD_MUNCP"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "NOM_MUNCP",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false
        },
        ZOOM_LAYERING : {
            BASE_LAYER_ID : "GEO09E04_MUNCP",
            QUERY_EXPRESSION : {
                LOGICAL_OPERATOR : null,
                QUERIES : [{FIELD : "CD_MUNCP", OPERATOR : "=", VALUE : undefined}]
            },
            SWITCH_SCALE : 100000
        }
    };
});
